import React, { useState } from "react";
import "./Charts.css";

/**
 * Horizontal stacked bars, one row per category. Bar length is the row's share
 * of the widest row; the segments split that length by band.
 *
 * `rows` is [{ label, share, parts: { [bandKey]: fraction } }] and `bands`
 * [{ key, label, color }] in stacking order.
 */
export default function StackedBar({ rows, bands, formatShare = (v) => `${v}%` }) {
  const [hover, setHover] = useState(null);
  const widest = Math.max(...rows.map((row) => row.share));

  return (
    <ul className="sbar">
      {rows.map((row) => {
        const total = bands.reduce(
          (sum, band) => sum + (row.parts[band.key] ?? 0),
          0
        );

        return (
          <li className="sbar__row" key={row.label}>
            <span className="sbar__label">{row.label}</span>

            <span className="sbar__track">
              <span
                className="sbar__bar"
                style={{ width: `${(row.share / widest) * 100}%` }}
              >
                {bands.map((band) => {
                  const part = row.parts[band.key] ?? 0;
                  if (!part) return null;
                  const key = `${row.label}-${band.key}`;
                  return (
                    <span
                      key={band.key}
                      className={`sbar__seg${
                        hover === key ? " sbar__seg--active" : ""
                      }`}
                      style={{
                        width: `${(part / total) * 100}%`,
                        background: band.color,
                      }}
                      title={`${row.label} — ${band.label}: ${Math.round(
                        (part / total) * 100
                      )}% of ${formatShare(row.share)}`}
                      onMouseEnter={() => setHover(key)}
                      onMouseLeave={() => setHover(null)}
                    />
                  );
                })}
              </span>
            </span>

            <span className="sbar__share">{formatShare(row.share)}</span>
          </li>
        );
      })}
    </ul>
  );
}
